export const METADATA_TYPES = {
    VEHICLE_TYPES: 'vehicleTypes',
    EQUIPMENT: 'equipment',
    LICENCES_CERTIFICATES: 'licencesCertificates',
    CUSTOM_LICENCES_CERTIFICATES: 'customLicencesCertificates',
    SUSTAINABILITY: 'sustainability',
    SNI_INDUSTRIES: 'sniIndustries',
    INDUSTRIES: 'industries'
};

export default METADATA_TYPES;
